export interface UiState {
  sideBarIsOpen: boolean;
  isFullscreen: boolean;
}

export const initialUiState: UiState = {
  sideBarIsOpen: true,
  isFullscreen: false,
};
